import { Component, OnInit } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { LoginService } from '../../../services/login/login.service';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { SecurityService } from 'app/services/security/security.service';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-nuevo-usuario',
  templateUrl: './nuevo-usuario.component.html',
  styleUrls: ['./nuevo-usuario.component.css'],
  providers: [MessagesTitles, MessagesStatus, DatePipe, DecimalPipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class NuevoUsuarioComponent implements OnInit {
  titulo: string;
  form: FormGroup;
  form2: FormGroup;
  form3: FormGroup;
  dataUser: any;
  user: any;
  ipAddress: any;
  editar: boolean;
  accionNuevo: boolean = true;
  accionEditar: boolean = false;
  id_empresa: any;
  RepEmpresaSeg: any;
  Empresa: any = "Empresa";
  RepEmpresaSegFilter: any;
  newList: any = [];

  constructor(
    private loginService: LoginService,
    private router: Router,
    private securityService: SecurityService,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus) {

    this.dataUser = this.loginService.dataUser;
    this.titulo = "Nuevo usuario";
    this.editar = false;

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.id_empresa = this.user.id_empresa;
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));

    this.form3 = new FormGroup({
      id_user: new FormControl(this.dataUser.id_user),
      id_sistemas: new FormControl('1', [Validators.required]),
      id_roles: new FormControl('1', [Validators.required]),
      Ruta: new FormControl('/dashboard', [Validators.required]),

      NombreProyecto: new FormControl('DigitalFactoring', []),
      Usuario: new FormControl(this.user.Usuario, []),
      Host: new FormControl('INTRANET', []),
      IP: new FormControl(this.ipAddress.ip, []),
      Canal: new FormControl('W', [])
    });
  }

  ngOnInit() {
    if (this.dataUser == undefined || this.dataUser == null) {
      this.router.navigate(['/usuarios/listado']);
    }

    if (this.loginService.dataUser != "") {
      this.titulo = "Editar Usuario";
      this.editar = true;
      this.accionNuevo = false;
      this.accionEditar = true;

      this.form2 = new FormGroup({
        id_user: new FormControl(this.dataUser.id_user),
        Nombre: new FormControl(this.dataUser.Nombre, [Validators.required]),
        Telefono: new FormControl(this.dataUser.Telefono, [Validators.required]),
        Usuario: new FormControl(this.dataUser.Usuario, [Validators.required]),
        Email: new FormControl(this.dataUser.Email, [Validators.required, Validators.email]),

        id_empresa: new FormControl(this.id_empresa, []),
        NombreProyecto: new FormControl('DigitalFactoring', []),
        Host: new FormControl('INTRANET', []),
        IP: new FormControl(this.ipAddress.ip, []),
        Canal: new FormControl('W', [])
      })
      this.form2.controls['Nombre'].setValue(this.dataUser.Nombre);
      this.form2.controls['Usuario'].setValue(this.dataUser.Usuario);
      this.form2.controls['Telefono'].setValue(this.dataUser.Telefono);
      this.form2.controls['Email'].setValue(this.dataUser.Email);

    } else {
      this.form = new FormGroup({
        Nombre: new FormControl("", [Validators.required]),
        Telefono: new FormControl("", [Validators.required]),
        Usuario: new FormControl("", [Validators.required]),
        Email: new FormControl("", [Validators.required, Validators.email]),
        id_empresa: new FormControl(""),
        Password: new FormControl("", [Validators.required, Validators.minLength(6)]),
        Repetir_Password: new FormControl("", [Validators.required, Validators.minLength(6)]),
        NombreProyecto: new FormControl('Intranet', []),
        Host: new FormControl('INTRANET', []),
        IP: new FormControl(this.ipAddress.ip, []),
        Canal: new FormControl('W', [])
      })
    }

    this.ObtenerListaEmpresaSeg();
  }

  guardarUsuario() {
    if (this.editar) {
      this.actualizarUsuario();
    } else {

      this.registrarUsuario();
    }
  }

  actualizarUsuario() {
    if (this.form2.invalid) {
      Swal.fire({
        title: "CAMPOS VALIDADOS",
        text: "Verificar los campos resaltados de color rojo",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
    }

    Swal.fire({
      title: 'Espere',
      text: 'Actualizando Información',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    this.loginService.editarUsuario(this.form2.getRawValue())
      .subscribe(resp => {
        Swal.fire({
          title: "Felicidades",
          text: "Usuario actualizado correctamente",
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then(res => {
          this.redirect(res);
        });
      }, (err: HttpErrorResponse) => {

        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "USUARIO NO ACTUALIZADO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      });
  }

  registrarUsuario() {
    if (this.id_empresa != 1) {
      this.form.controls['id_empresa'].setValue(this.id_empresa);
    }

    if (this.form.invalid) {
      Swal.fire({
        title: "CAMPOS VALIDADOS",
        text: "Verificar los campos resaltados de color rojo",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      })
      return;
    }
    Swal.fire({
      title: 'Espere',
      text: 'Guardado Información',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    this.loginService.createUsuario(this.form.getRawValue())
      .subscribe(resp => {
        if (this.form.controls['id_empresa'].value != 1 && this.id_empresa == 1) {
          this.Crearacceso(resp['id_user'])
        }
        Swal.fire({
          title: "Felicidades",
          text: "Usuario registrado correctamente",
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then(res => {

          this.redirect(res);

        });
      }, (err: HttpErrorResponse) => {

        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "USUARIO NO GUARDADO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      });
  }

  redirect(res: SweetAlertResult) {
    if (res.value) {
      this.loginService.clickGuard = true;
      this.router.navigate(['/usuarios/listado']);
    }
  }

  Crearacceso(id_user) {
    this.form3.controls['id_user'].setValue(id_user);
    this.securityService.RegistrarAcceso(this.form3.getRawValue())
      .subscribe();
  }

  ObtenerListaEmpresaSeg() {
    this.securityService.ObtenerListaEmpresaSeg().subscribe(
      resp => {
        this.RepEmpresaSeg = resp
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
      })
  }
}
